/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportMapping } from './ImportMapping';
import {
    ImportMappingFromJSON,
    ImportMappingFromJSONTyped,
    ImportMappingToJSON,
    ImportMappingToJSONTyped,
} from './ImportMapping';

/**
 * 
 * @export
 * @interface UpdateMappingProfileRequest
 */
export interface UpdateMappingProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMappingProfileRequest
     */
    name?: string | null;
    /**
     * 
     * @type {ImportMapping}
     * @memberof UpdateMappingProfileRequest
     */
    mapping?: ImportMapping;
}

/**
 * Check if a given object implements the UpdateMappingProfileRequest interface.
 */
export function instanceOfUpdateMappingProfileRequest(value: object): value is UpdateMappingProfileRequest {
    return true;
}

export function UpdateMappingProfileRequestFromJSON(json: any): UpdateMappingProfileRequest {
    return UpdateMappingProfileRequestFromJSONTyped(json, false);
}

export function UpdateMappingProfileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMappingProfileRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'mapping': json['mapping'] == null ? undefined : ImportMappingFromJSON(json['mapping']),
    };
}

export function UpdateMappingProfileRequestToJSON(json: any): UpdateMappingProfileRequest {
    return UpdateMappingProfileRequestToJSONTyped(json, false);
}

export function UpdateMappingProfileRequestToJSONTyped(value?: UpdateMappingProfileRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'mapping': ImportMappingToJSON(value['mapping']),
    };
}

